module.exports = __webpack_public_path__ + "img/map-marker.d5a36d48.png";